document.addEventListener("DOMContentLoaded", function () {
    var typeSelect = document.getElementById("TypeOfClient");
    var companyFields = document.getElementById("company-fields");

    function toggleCompanyFields() {
        if (typeSelect.value === "company") {
            companyFields.style.display = "";
            companyFields.querySelectorAll("input").forEach(function (input) {
                input.setAttribute("data-parsley-required", "true");
            });
        } else {
            companyFields.style.display = "none";
            companyFields.querySelectorAll("input").forEach(function (input) {
                input.removeAttribute("data-parsley-required");
            });
        }
    }

    typeSelect.addEventListener("change", toggleCompanyFields);
    toggleCompanyFields(); 
});
